export class BlazorLoader {
    static createWithWindowBlazorRuntime(msalAuthenticationContext, blazorAppDomRoot, loadingFilesDetailsContainerDomElement, blazorSplashContainer, loadingErrorContainer, loadingProgressMessageContainer, currentAppVersion) {
        const windowBlazorRuntime = window.Blazor;
        const result = new BlazorLoader(windowBlazorRuntime, msalAuthenticationContext, blazorAppDomRoot, loadingFilesDetailsContainerDomElement, blazorSplashContainer, loadingErrorContainer, loadingProgressMessageContainer, currentAppVersion);
        return result;
    }
    constructor(blazorRuntime, msalAuthenticationContext, blazorAppDomRoot, loadingFilesDetailsContainerDomElement, blazorSplashContainer, loadingErrorContainer, loadingProgressMessageContainer, currentAppVersion) {
        Object.defineProperty(this, "blazorRuntime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "msalAuthenticationContext", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "blazorAppDomRoot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loadingFilesDetailsContainerDomElement", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "blazorSplashContainer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loadingErrorContainer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loadingProgressMessageContainer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentAppVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "resourcesToLoadManually", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loadBlazor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (applicationInsights) => {
                console.log("Loading Blazor with CurrentVersion=", this.currentAppVersion);
                this.blazorAppDomRoot.setAttribute("style", "display: block;");
                const blazorStartingPerformanceNow = performance.now();
                try {
                    await this.blazorRuntime.start({
                        loadBootResource: (type, filename, defaultUri, integrity) => this.blazorLoadBootResource(type, filename, defaultUri, integrity)
                    });
                    const blazorLoadedPerformanceNow = performance.now();
                    const blazorLoadingDelay = blazorLoadedPerformanceNow - blazorStartingPerformanceNow;
                    console.log(`Blazor.start has completed successfully. It took ${blazorLoadingDelay} ms`);
                    if (applicationInsights) {
                        const properties = { ...this.createTelemetryCustomProperties(), blazorStartingPerformanceNow, blazorLoadedPerformanceNow, blazorLoadingDelay };
                        applicationInsights.trackEvent({ name: "Blazor.start has completed OK" }, properties);
                    }
                }
                catch (err) {
                    const blazorErrorPerformanceNow = performance.now();
                    const blazorErrorDelay = blazorErrorPerformanceNow - blazorStartingPerformanceNow;
                    console.error(`startBlazorWithCustomizations has failed after ${blazorErrorDelay} ms`, err);
                    if (applicationInsights) {
                        const properties = { ...this.createTelemetryCustomProperties(), blazorStartingPerformanceNow, blazorErrorPerformanceNow, blazorErrorDelay };
                        applicationInsights.trackEvent({ name: "Blazor.start has failed" }, properties);
                    }
                    throw err;
                }
            }
        });
        Object.defineProperty(this, "getLoadingDetails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const result = {
                    resourcesToLoadManually: BlazorLoaderStorage.getResourcesToLoadManually()
                };
                return result;
            }
        });
        Object.defineProperty(this, "blazorLoadBootResource", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type, filename, defaultUri, integrity) => {
                if (type === 'manifest' && filename === 'blazor.boot.json' && this.currentAppVersion && this.currentAppVersion.length > 0) {
                    filename = filename.replace(".json", `-${this.currentAppVersion}.json`);
                    defaultUri = defaultUri.replace(".json", `-${this.currentAppVersion}.json`);
                }
                const resourceToLoadManually = { type, filename, integrity, defaultUri, startTime: Date.now(), startPerformance: performance.now() };
                BlazorLoaderStorage.setResourceToLoadManually(resourceToLoadManually);
                console.debug("Resource added to the list of resources to download", resourceToLoadManually);
                switch (type) {
                    case 'dotnetjs': {
                        return null;
                    }
                    default: {
                        resourceToLoadManually.statusMessage = 'Downloading...';
                        const fetchPromise = this.fetchBlazorResourceWithExceptionHandling(resourceToLoadManually);
                        return fetchPromise;
                    }
                }
            }
        });
        Object.defineProperty(this, "fetchBlazorResourceWithExceptionHandling", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (resourceToLoadManually) => {
                try {
                    const fetchResponse = await fetch(resourceToLoadManually.defaultUri, {
                        method: "GET",
                        mode: "same-origin",
                        credentials: "same-origin",
                        redirect: "error",
                        referrerPolicy: "same-origin",
                        cache: 'no-cache',
                        integrity: resourceToLoadManually.integrity,
                        headers: {}
                    });
                    resourceToLoadManually.endPerformance = performance.now();
                    resourceToLoadManually.endTime = Date.now();
                    resourceToLoadManually.fetchStatus = fetchResponse.status;
                    resourceToLoadManually.fetchStatusText = fetchResponse.statusText;
                    resourceToLoadManually.wasDownloadedOK = fetchResponse.ok;
                    resourceToLoadManually.statusMessage = resourceToLoadManually.wasDownloadedOK ? "Downloaded OK" : "Download Failed";
                    if (resourceToLoadManually.wasDownloadedOK) {
                        console.debug('Updated resource after it has been fetched', resourceToLoadManually);
                        this.updateLoadingProgressIndicator();
                    }
                    else {
                        console.warn('Showing error details after resource failed to be fetched', resourceToLoadManually);
                        this.showLoadingProgressDetails();
                    }
                    return fetchResponse;
                }
                catch (err) {
                    resourceToLoadManually.endPerformance = performance.now();
                    resourceToLoadManually.endTime = Date.now();
                    resourceToLoadManually.wasDownloadedOK = false;
                    resourceToLoadManually.statusMessage = 'Download Failed (Exception)';
                    resourceToLoadManually.errorDetails = err;
                    console.warn("Updated resource after fetch exception", resourceToLoadManually);
                    this.updateLoadingProgressIndicator();
                    this.showLoadingProgressDetails();
                    try {
                        if (window.appInsights) {
                            const properties = { ...this.createTelemetryCustomProperties(), SystemFile: resourceToLoadManually.defaultUri, ExpectedIntegrity: resourceToLoadManually.integrity, Error: JSON.stringify(err) };
                            window.appInsights.trackEvent({ name: "DownloadSystemFileFailed" }, properties);
                        }
                    }
                    catch (appInsightsError) {
                        console.log("Failed to send telemetry to AppInsights", appInsightsError);
                    }
                    throw err;
                }
                finally {
                    BlazorLoaderStorage.setResourceToLoadManually(resourceToLoadManually);
                }
            }
        });
        Object.defineProperty(this, "showLoadingProgressDetails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const loadingProgressDetailsTableContent = this.buildLoadingProgressDetailsTableContent();
                this.loadingFilesDetailsContainerDomElement.innerHTML = loadingProgressDetailsTableContent;
                this.blazorSplashContainer.style.display = "none";
                this.loadingErrorContainer.style.display = "block";
            }
        });
        Object.defineProperty(this, "buildLoadingProgressDetailsTableContent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const dateTimeFormat = new Intl.DateTimeFormat("en-GB", {
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                    fractionalSecondDigits: 3
                });
                let result = `<thead>
    <tr>
        <th>#</th>
        <th>File Name</th>
        <th>Status</th>
        <th>Status Code</th>
        <th>Hash</th>
        <th>Start Time</th>
        <th>End Time</th>
        <th>Delay (ms)</th>
        <th>Error?</th>
    </tr>
</thead>
<tbody>
`;
                let i = 0;
                for (let resourceToLoadManuallyKey in this.resourcesToLoadManually) {
                    const resourceToLoadManually = this.resourcesToLoadManually.get(resourceToLoadManuallyKey);
                    if (resourceToLoadManually) {
                        const error = resourceToLoadManually.errorDetails;
                        let errorMessage = "";
                        if (error) {
                            errorMessage = `${error.name}: ${error.message}`;
                        }
                        i++;
                        const color = resourceToLoadManually.wasDownloadedOK == true
                            ? "rgb(9,154,108)"
                            : resourceToLoadManually.wasDownloadedOK == false
                                ? "#f64e62"
                                : "rgb(255,182,36)";
                        result +=
                            `<tr style="color: ${color}">
    <td>${i}</td>
    <td title="URL: ${resourceToLoadManually.defaultUri}">${resourceToLoadManually.filename}</td>
    <td>${resourceToLoadManually.fetchStatus ?? ""}</td>
    <td>${resourceToLoadManually.fetchStatusText}</td>
    <td>${resourceToLoadManually.integrity}</td>
    <td>${dateTimeFormat.format(resourceToLoadManually.startTime)}</td>
    <td>${dateTimeFormat.format(resourceToLoadManually.endTime)}</td>
    <td>${resourceToLoadManually.endPerformance ? Math.trunc(resourceToLoadManually.endPerformance - resourceToLoadManually.startPerformance) : "?"} </td>
    <td>${errorMessage}</td>
</tr>`;
                    }
                }
                result += '</tbody>';
                return result;
            }
        });
        Object.defineProperty(this, "createTelemetryCustomProperties", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const activeAccount = this.msalAuthenticationContext.getActiveAccount();
                const result = {
                    performanceNow: performance.now(),
                    ApplicationVersion: this.currentAppVersion,
                    CurrentUserId: activeAccount?.localAccountId,
                    CurrentUserEmail: activeAccount?.username
                };
                return result;
            }
        });
        this.blazorRuntime = blazorRuntime;
        this.msalAuthenticationContext = msalAuthenticationContext;
        this.blazorAppDomRoot = blazorAppDomRoot;
        this.loadingFilesDetailsContainerDomElement = loadingFilesDetailsContainerDomElement;
        this.blazorSplashContainer = blazorSplashContainer;
        this.loadingErrorContainer = loadingErrorContainer;
        this.loadingProgressMessageContainer = loadingProgressMessageContainer;
        this.currentAppVersion = currentAppVersion;
        this.resourcesToLoadManually = new Map();
    }
    updateLoadingProgressIndicator() {
        const loadingPercentage = document.documentElement.style.getPropertyValue('--blazor-load-percentage-text').replaceAll('"', '');
        this.loadingProgressMessageContainer.setAttribute("title", `${loadingPercentage}%`);
        let hasAtLeastOneBlazorResourceFailed = false;
        for (let resourceToLoadManually of this.resourcesToLoadManually.values()) {
            hasAtLeastOneBlazorResourceFailed || (hasAtLeastOneBlazorResourceFailed = resourceToLoadManually.wasDownloadedOK ?? false);
            if (hasAtLeastOneBlazorResourceFailed) {
                break;
            }
        }
        if ((loadingPercentage === "99%" || loadingPercentage === "100%") && !hasAtLeastOneBlazorResourceFailed) {
            this.loadingProgressMessageContainer.innerHTML = "All resources loaded... the system is now starting.";
        }
        else {
            this.loadingProgressMessageContainer.innerHTML = loadingPercentage;
        }
        console.debug(`Updated loading progress indicator to ${loadingPercentage}%`);
    }
}
class BlazorLoaderStorage {
    static reset() {
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key?.startsWith(BlazorLoaderStorage.localStorageResourcesToLoadManuallyKeyPrefix)) {
                localStorage.removeItem(key);
            }
        }
    }
    static setResourceToLoadManually(blazorResourceToLoad) {
        const serialized = JSON.stringify(blazorResourceToLoad);
        localStorage.setItem(`${BlazorLoaderStorage.localStorageResourcesToLoadManuallyKeyPrefix}-${blazorResourceToLoad.filename}`, serialized);
    }
    static getResourcesToLoadManually() {
        const result = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key?.startsWith(BlazorLoaderStorage.localStorageResourcesToLoadManuallyKeyPrefix)) {
                const serializedBlazorResourceToLoad = localStorage.getItem(key);
                if (serializedBlazorResourceToLoad) {
                    const blazorResourceToLoad = JSON.parse(serializedBlazorResourceToLoad);
                    result.push(blazorResourceToLoad);
                }
            }
        }
        return result;
    }
    static areThereMoreThan2() {
        let count = 0;
        for (let i = 0; i < localStorage.length && count <= 2; i++) {
            const key = localStorage.key(i);
            if (key?.startsWith(BlazorLoaderStorage.localStorageResourcesToLoadManuallyKeyPrefix)) {
                count++;
            }
        }
        return count > 2;
    }
}
Object.defineProperty(BlazorLoaderStorage, "localStorageResourcesToLoadManuallyKeyPrefix", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: "resourcesToLoadManually"
});
